<script>
import CoreComponent from '../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue'

export default {
  extends: CoreComponent,
  data() {
    return {
      componentId: null,
      selectedTags: {},
      currentPage: 1,
      itemsPerPage: 15,
      showLoadMoreEnabled: false,
      totalServerCount: 0,
      totalLoadedItems: 0,
      hasReachedEnd: false,
      selectedFacetsContainer: null,
      selectedFacetsRow: null
    }
  },
  mounted() {
    this.componentId = this.cmpEl.getAttribute('data-component-id') || this.cmpEl.id

    const newsContainer = this.getElement('[id^="news-items-container-"]')
    if (newsContainer) {
      const limitValue = newsContainer.getAttribute('data-news-list-limit')
      if (limitValue) {
        this.itemsPerPage = parseInt(limitValue) || 15
      }

      const hideLoadMore = newsContainer.getAttribute('data-hide-load-more')
      this.showLoadMoreEnabled = hideLoadMore !== 'true'

      const totalCount = newsContainer.getAttribute('data-total-count')
      if (totalCount) {
        this.totalServerCount = parseInt(totalCount) || 0
      }
    }

    this.initYearFilters()
    this.initFilterDropdowns()
    this.initSelectedFacets()
    this.initFilterToggleButtons()

    this.fetchNewsByTag('', '', '', 1)
  },
  methods: {
    getElement(selector) {
      return this.cmpEl.querySelector(selector)
    },

    getElements(selector) {
      return this.cmpEl.querySelectorAll(selector)
    },

    initYearFilters() {
      const yearFiltersList = this.getElement(`#year-filters-list-${this.componentId}`)
      if (yearFiltersList) {
        const filterStartYear = parseInt(yearFiltersList.dataset.startYear) || 2020
        const filterEndYear = new Date().getFullYear()
        let filters = ''
        for (let i = filterEndYear; i >= filterStartYear; i--) {
          filters += `<li><a href="#" class="year-filter">${i}</a></li>`
        }
        yearFiltersList.innerHTML = filters
      }
    },

    initFilterDropdowns() {
      const blockFilterByElements = this.getElements('.block__filter-by')
      blockFilterByElements.forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault()
          element.classList.toggle('active')
          if (event.target.nextElementSibling) {
            event.target.nextElementSibling.classList.toggle('active')
          }
        })
      })
    },

    initSelectedFacets() {
      this.selectedFacetsContainer = this.getElement('.selected-facets-container')
      this.selectedFacetsRow = this.getElement('.selected-facets-row')
      const clearAllLink = this.getElement('.clear-all-facets-link')

      const listItems = this.getElements('.block__filters li a')
      const dropDownCategory = this.getElements('.dropdown-subcategory li a')
      const newsListItems = this.getElements('.newstype-list li a')
      const combinedItems = [...listItems, ...newsListItems]

      combinedItems.forEach((item) => {
        item.addEventListener('click', this.handleItemClick)
      })

      if (clearAllLink) {
        clearAllLink.addEventListener('click', (event) => {
          event.preventDefault()
          this.clearAllFacets()
        })
      }

      if (this.selectedFacetsContainer) {
        this.selectedFacetsContainer.addEventListener('click', (event) => {
          this.handleFacetRemoval(event, listItems, dropDownCategory)
        })
      }
    },

    initFilterToggleButtons() {
      // Get filter wrapper elements
      const businessFilters = this.getElement('.business-filters-wrapper')
      const monthYearFilters = this.getElement('.month-year-filters-wrapper')

      // Get toggle button containers
      const businessFiltersToggle = this.getElement('.toggle-all-filters')
      const monthYearToggle = this.getElement('.toggle-month-year-filters')

      // Setup Business/Corporate filters toggle
      if (businessFiltersToggle) {
        const showBtn = businessFiltersToggle.querySelector('.btn-show')
        const hideBtn = businessFiltersToggle.querySelector('.btn-hide')

        if (showBtn) {
          showBtn.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            showBtn.style.display = 'none'
            if (hideBtn) hideBtn.style.display = 'block'
            if (businessFilters) businessFilters.classList.add('active')
          })
        }

        if (hideBtn) {
          hideBtn.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            hideBtn.style.display = 'none'
            if (showBtn) showBtn.style.display = 'block'
            if (businessFilters) businessFilters.classList.remove('active')
          })
        }
      }

      // Setup Month/Year filters toggle
      if (monthYearToggle) {
        const showBtn = monthYearToggle.querySelector('.btn-show')
        const hideBtn = monthYearToggle.querySelector('.btn-hide')

        if (showBtn) {
          showBtn.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            showBtn.style.display = 'none'
            if (hideBtn) hideBtn.style.display = 'block'
            if (monthYearFilters) monthYearFilters.classList.add('active')
          })
        }

        if (hideBtn) {
          hideBtn.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            hideBtn.style.display = 'none'
            if (showBtn) showBtn.style.display = 'block'
            if (monthYearFilters) monthYearFilters.classList.remove('active')
          })
        }
      }
    },

    clearAllFacets() {
      while (this.selectedFacetsContainer.firstChild) {
        this.selectedFacetsContainer.removeChild(this.selectedFacetsContainer.firstChild)
      }
      this.selectedFacetsRow.classList.add('hidden')

      const selectedElements = this.getElements('.filter-sidebar .selected')
      selectedElements.forEach((element) => element.classList.remove('selected'))

      this.selectedTags = {}
      this.fetchNewsByTag('', '', '', 1)
    },

    handleFacetRemoval(event, listItems, dropDownCategory) {
      if (
        event.target.classList.contains('selected-facet-link') ||
        event.target.classList.contains('close-icon')
      ) {
        const selectedFacetElement = event.target.closest('.selected-facet')
        const tagLink = selectedFacetElement.querySelector('.selected-facet-link')
        const itemName = tagLink.textContent
        const tagId = tagLink.getAttribute('data-tag-id')
        const classList = tagLink.classList

        const combinedItems = [...listItems, ...dropDownCategory]
        const originalItem = Array.from(combinedItems).find(
          (item) => item.textContent === itemName
        )
        if (originalItem) {
          originalItem.classList.remove('selected')
        }

        let tagType
        let tagValue = tagLink.dataset.value || tagLink.textContent.trim()

        if (classList.contains('market-tags')) {
          tagType = 'Market'
        } else if (classList.contains('product-tags')) {
          tagType = 'Product'
        } else if (classList.contains('corporate-tags')) {
          tagType = 'Corporate'
        } else if (classList.contains('year-filter')) {
          tagType = 'year'
        } else if (classList.contains('month-filter')) {
          tagType = 'month'
        }

        if (tagType) {
          this.removeTag(tagType, tagValue, tagId)
        }

        selectedFacetElement.remove()

        if (this.selectedFacetsContainer.children.length === 0) {
          this.selectedFacetsRow.classList.add('hidden')
        }

        this.fetchNewsByTag('', '', '', 1)
      }
    },

    fetchNewsByTag(tagValue, tagType, tagId, page = 1) {
      const newsListComponent = this.getElement('[id^="news-items-container-"]')
      if (!newsListComponent) {
        console.error('News container not found for component:', this.componentId)
        return
      }

      const newsPathValue = newsListComponent.getAttribute('data-news-path')

      let fullURL = window.location.href
      let basePart = fullURL.split('?')[0].split('#')[0]
      basePart = basePart.replace('.html', '')
      let servletURL = basePart + '/.dow.newslist.json'

      this.currentPage = page || 1

      if (this.currentPage === 1) {
        this.totalLoadedItems = 0
        this.hasReachedEnd = false
      }

      const params = {
        newsPath: newsPathValue ? newsPathValue : '',
        page: this.currentPage,
        limit: this.itemsPerPage
      }

      Object.assign(params, this.selectedTags)

      const queryString = Object.keys(params)
        .map((key) => {
          let value = params[key]
          if (Array.isArray(value)) {
            value = value.join('|')
          } else {
            value = encodeURIComponent(value)
              .replace(/%2F/g, '/')
              .replace(/%3A/g, ':')
          }
          return `${encodeURIComponent(key)}=${value}`
        })
        .join('&')

      const xhr = new XMLHttpRequest()
      xhr.open('GET', `${servletURL}?${queryString}`, true)
      xhr.onload = () => {
        if (xhr.status === 200) {
          const newsData = JSON.parse(xhr.responseText)
          this.updateNewsList(newsData, this.currentPage)

          if (this.currentPage === 1) {
            this.totalLoadedItems = newsData.length
          } else {
            this.totalLoadedItems += newsData.length
          }

          const receivedLessThanRequested = newsData.length < this.itemsPerPage
          const receivedZeroItems = newsData.length === 0

          if (receivedLessThanRequested || receivedZeroItems) {
            this.hasReachedEnd = true
          }

          this.updateLoadMoreState()
        } else {
          console.error('Error fetching data for component', this.componentId, ':', xhr.statusText)
        }
      }
      xhr.onerror = () => {
        console.error('Network error fetching data for component:', this.componentId)
      }
      xhr.send()
    },

    updateNewsList(newsData, page = 1) {
      const container = this.getElement(`#news-items-container-${this.componentId}`)
      if (!container) {
        console.error('News items container not found for component:', this.componentId)
        return
      }

      let htmlContent = ''
      newsData.forEach((item) => {
        const formattedDate = this.formatDate(item.releaseDate)
        htmlContent += `
          <li>
            <a href="${item.path}">
              <p class="list__date">${formattedDate}</p>
              <div>
                <h3 class="headings__color--blue typography--arial headings__alignment--left">
                  ${item.title}<i class="list__arrow"></i>
                </h3>
              </div>
              <p class="list__info">${item.description || ''}</p>
            </a>
          </li>
        `
      })

      if (page === 1) {
        container.innerHTML = htmlContent
      } else {
        container.innerHTML += htmlContent
      }
    },

    updateLoadMoreState() {
      const loadMoreContainer = this.getElement(`#load-more-container-${this.componentId}`)
      const endOfItemsContainer = this.getElement(`#end-of-list-${this.componentId}`)

      if (!loadMoreContainer || !endOfItemsContainer) {
        return
      }

      const loadMoreButton = loadMoreContainer.querySelector('.load-more-button a')
      if (loadMoreButton) {
        const newButton = loadMoreButton.cloneNode(true)
        loadMoreButton.parentNode.replaceChild(newButton, loadMoreButton)

        newButton.addEventListener('click', (e) => {
          e.preventDefault()
          this.fetchNewsByTag('', '', '', this.currentPage + 1)
        })
      }

      if (this.hasReachedEnd) {
        // Hide load more, show end of items (partial)
        loadMoreContainer.style.display = 'none'
        if (this.totalLoadedItems > 0) {
          endOfItemsContainer.style.display = 'block'
        }
      } else if (this.showLoadMoreEnabled && this.totalLoadedItems > 0) {
        // Show load more button if enabled and we have items
        loadMoreContainer.style.display = 'flex'
        endOfItemsContainer.style.display = 'none'
      } else {
        // Hide both
        loadMoreContainer.style.display = 'none'
        endOfItemsContainer.style.display = 'none'
      }
    },

    formatDate(dateString) {
      if (!dateString) return ''

      const parts = dateString.split('/')
      if (parts.length !== 3) return dateString

      const month = parseInt(parts[0], 10) - 1
      const day = parseInt(parts[1], 10)
      const year = parseInt(parts[2], 10)
      const date = new Date(year, month, day)

      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }

      let urlLocale = window.location.pathname.split('/')[1] || 'en-us'
      return date.toLocaleDateString(urlLocale, options)
    },

    addTag(tagType, tagValue, tagId) {
      if (!this.selectedTags[tagType]) {
        this.selectedTags[tagType] = []
      } else if (!Array.isArray(this.selectedTags[tagType])) {
        this.selectedTags[tagType] = [this.selectedTags[tagType]]
      }

      const value = tagType === 'year' || tagType === 'month' ? tagValue : tagId

      if (!this.selectedTags[tagType].includes(value)) {
        this.selectedTags[tagType].push(value)
      }
    },

    removeTag(tagType, tagValue, tagId) {
      const value = tagType === 'year' || tagType === 'month' ? tagValue : tagId

      if (this.selectedTags[tagType]) {
        this.selectedTags[tagType] = this.selectedTags[tagType].filter(
          (t) => t !== value
        )
        if (this.selectedTags[tagType].length === 0) {
          delete this.selectedTags[tagType]
        }
      }
    },

    handleItemClick(event) {
      event.preventDefault()
      const target = event.target
      const tagValue = target.dataset.value || target.textContent.trim()
      const tagId = target.getAttribute('data-tag-id')

      let tagType
      if (target.classList.contains('market-tags')) {
        tagType = 'Market'
      } else if (target.classList.contains('product-tags')) {
        tagType = 'Product'
      } else if (target.classList.contains('corporate-tags')) {
        tagType = 'Corporate'
      } else if (target.classList.contains('year-filter')) {
        tagType = 'year'
      } else if (target.classList.contains('month-filter')) {
        tagType = 'month'
      }

      if (tagType) {
        if (tagType === 'year' || tagType === 'month') {
          this.addTag(tagType, tagValue)
          this.fetchNewsByTag(tagValue, tagType, tagValue, 1)
        } else {
          this.addTag(tagType, null, tagId)
          this.fetchNewsByTag(tagValue, tagType, tagId, 1)
        }
      }

      if (!target.classList.contains('selected')) {
        this.selectedFacetsRow.classList.remove('hidden')

        const clonedItem = target.cloneNode(true)
        clonedItem.classList.add('selected-facet-link')

        const facetBox = document.createElement('div')
        facetBox.classList.add('facet-box')

        const selectedFacet = document.createElement('div')
        selectedFacet.classList.add('selected-facet')

        const closeIcon = document.createElement('div')
        closeIcon.classList.add('close-icon')

        facetBox.appendChild(clonedItem)
        facetBox.appendChild(closeIcon)
        selectedFacet.appendChild(facetBox)

        target.classList.add('selected')
        this.selectedFacetsContainer.appendChild(selectedFacet)
      }
    }
  }
}
</script>

<style lang="scss">
@import './corporate-news-list.scss';
</style>
